export { initDatadog } from './initDatadog';
